// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveSecondaryCipNumberDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryCipNumberDTO from '../models/SecondaryCipNumberDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    secondaryCipNumberId: string | null | null;
    secondaryCipNumber: SecondaryCipNumberDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            secondaryCipNumberId: null,
            secondaryCipNumber: null,
        },
        initValues);
    },
    secondaryCipNumberId: 'secondaryCipNumberId',
    secondaryCipNumber: 'secondaryCipNumber',
}

interface Result extends ResultDTO {
    secondaryCipNumber: SecondaryCipNumberDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryCipNumber: null,
        },
        initValues);
    },
    secondaryCipNumber: 'secondaryCipNumber',
}

export { Request, Result };